export class AreaIGatewayModel {
  public equivalent_profile_user: string;
  public notes: string;
}
